export default __webpack_public_path__ + "static/media/logo.ce92be70.svg";